export default __webpack_public_path__ + "static/fun.hover-088913425bde76b5dfb40d71e13133b6.jpg";